import { Image } from "./image";
import React from "react";

export const Products = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Products</h2>
          <p>
            Our products include
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.filter(data=>data.src).map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      largeImage={d.src}
                      smallImage={d.src}
                    />
                    <p>{d.title}</p>
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
        <div className="row">
          <hr/>
          <div className="portfolio-items" style={{marginTop:'30px'}}>
            {props.data
              ? props.data.filter(data=>!data.src).map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                    <p>{d.title}</p>
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
        
      </div>
    </div>
  );
};
